import { env } from 'next-runtime-env';
import featureSchema from '@/core/schemas/feature-schema';

function readFeatureFlagEnv(flagName: string): string {
  const key = `NEXT_PUBLIC_FEATURE_${flagName}`;
  const enabledKey = `${key}_ENABLED`;

  return env(key) ?? env(enabledKey) ?? process.env[enabledKey] ?? '';
}

const featureAccessoriesEnvValue = readFeatureFlagEnv('ACCESSORIES');

const featureReturnFlowEnvValue = readFeatureFlagEnv('RETURN_FLOW');

const featureStorageBagEnvValue = readFeatureFlagEnv('STORAGE_BAG');

const featureBookingToolEnvValue = readFeatureFlagEnv('BOOKING_TOOL');

const featureCustomerServiceFormEnvValue =
  readFeatureFlagEnv('CUSTOMER_SERVICE_FORM');

const featureProductsSliderEnvValue = readFeatureFlagEnv('PRODUCTS_SLIDER');

const featureRelaxationMaskEnvValue = readFeatureFlagEnv('RELAXATION_MASK');

const featureAppPageEnvValue = readFeatureFlagEnv('APP_PAGE');

const featureExpansionMarketsOrderFlowEnvValue = readFeatureFlagEnv(
  'EXPANSION_MARKETS_ORDER_FLOW',
);

const featureLifetimeSubscriptionEnvValue =
  readFeatureFlagEnv('LIFETIME_SUBSCRIPTION');

const featureAccountSubscriptionActionsEnvValue = readFeatureFlagEnv(
  'ACCOUNT_SUBSCRIPTION_ACTIONS',
);

const featureSocialLoginEnvValue = readFeatureFlagEnv('SOCIAL_LOGIN');

const featureMagazineEnvValue = readFeatureFlagEnv('MAGAZINE');

const DEFAULT_FEATURE_FLAGS = featureSchema.parse({
  FEATURE_ACCESSORIES: featureAccessoriesEnvValue,
  FEATURE_RETURN_FLOW: featureReturnFlowEnvValue,
  FEATURE_STORAGE_BAG: featureStorageBagEnvValue,
  FEATURE_BOOKING_TOOL: featureBookingToolEnvValue,
  FEATURE_CUSTOMER_SERVICE_FORM: featureCustomerServiceFormEnvValue,
  FEATURE_PRODUCTS_SLIDER: featureProductsSliderEnvValue,
  FEATURE_RELAXATION_MASK: featureRelaxationMaskEnvValue,
  FEATURE_APP_PAGE: featureAppPageEnvValue,
  FEATURE_EXPANSION_MARKETS_ORDER_FLOW:
    featureExpansionMarketsOrderFlowEnvValue,
  FEATURE_LIFETIME_SUBSCRIPTION: featureLifetimeSubscriptionEnvValue,
  FEATURE_ACCOUNT_SUBSCRIPTION_ACTIONS:
    featureAccountSubscriptionActionsEnvValue,
  FEATURE_SOCIAL_LOGIN: featureSocialLoginEnvValue,
  FEATURE_MAGAZINE: featureMagazineEnvValue,
});

export default DEFAULT_FEATURE_FLAGS;
